//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "rows-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};